
import Vue from 'vue'
export default Vue.extend({
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    description: {
      type: String,
      default: '',
      required: false,
    },
    num: {
      type: Number,
      default: 0,
      required: false,
    },
    isRightNumber: {
      type: Boolean,
      required: false,
      default: false,
    },
    borderRadius: {
      type: String,
      required: false,
      default: '20px',
    },
  },
})
